import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.scss';
import { useTranslation } from 'react-i18next';

const sidebarContent = [
  { label: 'dashboard', link: 'dashboard' },
  {
    label: 'User Management',
    link: null,
    subItems: [
      { label: 'users', link: '/user' },
      { label: 'teams', link: '/team' },
      { label: 'delegations', link: '/user/delegation' },
    ],
  },
  {
    label: 'Access Management',
    link: null,
    subItems: [
      { label: 'features', link: '/permission/feature/list' },
      { label: 'roles', link: '/permission/role/list' },
      { label: 'groups', link: '/permission/group/list' },
    ],
  },
  { label: 'session', link: '/session' },
  { label: 'application', link: '/application' },
  { label: 'platform', link: '/platform' },
];

const RenderSidebarItem = ({ item }: any) => {
  const { t } = useTranslation(['sidebar']);

  return (
    <li>
      {item.link ? (
        <NavLink end className={({ isActive }) => (isActive ? styles.active : '')} to={item.link}>
          {t(item.label)}
        </NavLink>
      ) : (
        <>
          <span>{t(item.label)}</span>
          <ul>
            {item.subItems?.map((subItem: any, index: any) => (
              <RenderSidebarItem key={index} item={subItem} />
            ))}
          </ul>
        </>
      )}
    </li>
  );
};

const RenderSidebarNavigation = () => (
  <div className={styles['sidebar-navigation']}>
    <nav>
      <ul>
        {sidebarContent.map((item, index) => (
          <RenderSidebarItem key={index} item={item} />
        ))}
      </ul>
    </nav>
  </div>
);

export const Sidebar = () => (
  <div className={styles['sidebar']}>
    <RenderSidebarNavigation />
  </div>
);

export default Sidebar;
